import { render, staticRenderFns } from "./EboardApplicationForm.vue?vue&type=template&id=bc828bea"
import script from "./EboardApplicationForm.vue?vue&type=script&lang=js"
export * from "./EboardApplicationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EboardApplicationForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CountryDropdown: require('/vercel/path0/components/ui/CountryDropdown.vue').default})
